module.exports = __webpack_public_path__ + "static/media/avatar.bdfc48e5.png";